"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getManagerWithSession = void 0;

var _CompositionManager = _interopRequireDefault(require("composer-lib/data/CompositionManager"));

var _LockManager = _interopRequireDefault(require("composer-lib/data/LockManager"));

var managers = {
  composition: null,
  lock: null
};

function getNewManagerWithSession(managerType, session) {
  var Manager;

  if (managerType === 'composition') {
    Manager = _CompositionManager.default;
  } else if (managerType === 'lock') {
    Manager = _LockManager.default;
  }

  return new Manager(session);
}

var getManagerWithSession = function getManagerWithSession(managerType, session) {
  var manager = managers[managerType];

  if (!manager) {
    managers[managerType] = getNewManagerWithSession(managerType, session);
    manager = managers[managerType];
  } else if (session) {
    manager.setSession(session);
  }

  return manager;
};

exports.getManagerWithSession = getManagerWithSession;